export const continents = [
  {
      continentNameFin: "Aasia",
      continentNameEng: "Asia",
      continentZoom: 2,
      center: [4,110]
  },
  {
      continentNameFin: "EU-maat",
      continentNameEng: "European Union",
      continentZoom: 3,
      center: [50,20]
  },
  {
      continentNameFin: "Muu Eurooppa",
      continentNameEng: "Other Europe",
      continentZoom: 3,
      center: [57,25]
  },
  {
      continentNameFin: "Pohjois-Amerikka",
      continentNameEng: "Northern America",
      continentZoom: 2,
      center: [62,-97]
  },
  {
      continentNameFin: "Saharan eteläpuolinen Afrikka",
      continentNameEng: "Sub-Saharan Africa",
      continentZoom: 3,
      center: [3,21]
  },
  {
      continentNameFin: "Lähi-itä, Pohjois-Afrikka",
      continentNameEng: "Middle East, Northern Africa",
      continentZoom: 3,
      center: [20,21]
  },
  {
      continentNameFin: "Etelä- ja Keski-Amerikka",
      continentNameEng: "Southern and Central America",
      continentZoom: 2,
      center: [-16,-64]
  },

]